import { QueryKey as PackageQueryKey } from '@tanstack/react-query';

import { PagedParams } from './types/GeneralTypes';

export type QueryKey = PackageQueryKey;

export interface QueryMapKey {
  _root: string;
  paged: (params: PagedParams) => QueryKey;
  one: (id: string | number | null) => QueryKey;
  editableOne: (id: string | number) => QueryKey;
  list: () => QueryKey;
  as: (key: (object | string | number | undefined | null | unknown)[]) => QueryKey;
  root: () => QueryKey;
}

export function getQueryKey(root: string): QueryMapKey {
  return {
    _root: root,
    root: () => [root],
    paged: (params: PagedParams) => [root, 'paged', params],
    one: (id: string | number | null) => [root, id, 'one'],
    editableOne: (id: string | number) => [root, id, 'one', 'editable'],
    list: () => [root, 'list'],
    as: (key: (object | string | number | undefined | null | unknown)[]) => [root, ...key],
  };
}
